import {noop} from '@github-ui/noop'
import {createContext, type PropsWithChildren, type RefObject} from 'react'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {ViewMode} from './utils/view-mode'

export const ContextualCommentControlsContext = createContext(false)

export function ContextualCommentControlsProvider({children}: PropsWithChildren) {
  const enabled = isFeatureEnabled('prs_contextual_comment_controls') === true
  return <ContextualCommentControlsContext value={enabled}>{children}</ContextualCommentControlsContext>
}

export interface CommentsContext {
  contextualCommentControls?: boolean
  viewMode: ViewMode
  setViewMode: (viewMode: ViewMode) => void
  viewSwitchRef?: RefObject<HTMLDivElement | null>
  /** Tab size to use for rendering code snippet previews. */
  tabSize?: number
  /** Unique anchor prefix to prepend to comment IDs. */
  commentAnchorPrefix?: string
  /** Indicates where comments are being rendered. */
  surface?: 'page' | 'panel'
}

export const CommentsContext = createContext<CommentsContext>({
  viewMode: ViewMode.ThreadPreviews,
  setViewMode: noop,
  tabSize: 4,
})
